const TransactionTypes = {
  PURCHASE_NOTE: 'PURCH-NEW',
  FUNDING: 'FUND-ACCT',
  SELL_REINVEST: 'SELL-REINVEST',
  SELL_DONATE: 'SELL-DONATE',
  SELL_MATURE: 'SELL-MATURE',
  SELL_REDEEM_FULL: 'SELL-REDEEM-FULL',
  SELL_REDEEM_PARTIAL: 'SELL-REDEEM-PARTIAL',
  ACCRINT: 'ACCRINT',
  PURCH_COMMISSION: 'PURCH-COMMISSION',
  REPAID_ACCT: 'REPAID-ACCT',
  PAID_INT: 'PAID-INT',
  SERV_FEE: 'SERV-FEE',
  FEE_SERV: 'FEE-SERV',
  REPAID_ACCT_FULL: 'REPAID-ACCT-FULL',
  REPAID_ACCT_PARTIAL: 'REPAID-ACCT-PARTIAL',
  INT_REINVEST: 'INT-REINVEST',
  INT_PAID: 'INT-PAID',
  INT_DONATE: 'INT-DONATE',
  ADDITIONAL_DEPOSIT: 'ADDITIONAL-DEPOSIT',
  PURCH_INT_REINVEST: 'PURCH-INT-REINVEST',
  PURCH_REINVEST: 'PURCH-REINVEST',
  PURCH_RENEWAL: 'PURCH-RENEWAL',
  PURCH_INT_CAP: 'PURCH-INT-CAP',
  ACCT_TRANSFER: 'ACCT-TRANSFER',
  SETTLEMENT: 'SETTLEMENT',
};

export default TransactionTypes;



// WEBPACK FOOTER //
// ./src/data/static/transactionTypes.js